<template>
    <div class="layout-root">
        <el-container>
            <el-header>
                <layout-header></layout-header>
            </el-header>
            <el-container v-if="!isIndex">
                <el-aside style="width: 220px;">
                    <layout-aside></layout-aside>
                </el-aside>
                <el-main>
                    <div class="root-content">
                        <div class="crumbs-wrapper">
                          <el-breadcrumb separator="/">
                            <el-breadcrumb-item :to="item.path" v-for="(item,index) in breadcrumbList" :key="index">{{item.name}}</el-breadcrumb-item>
                          </el-breadcrumb>
                          <div class="merchant-name">{{merchantName}}</div>
                        </div>
                        <div class="view-wrapper">
                          <router-view></router-view>
                        </div>
                    </div>
                </el-main>
            </el-container>
            <div v-else>
                <el-main>
                    <div class="root-content">
                        <router-view></router-view>
                    </div>
                </el-main>
            </div>
        </el-container>
        <el-dialog title="修改密码" :visible.sync="modifyPasswordDialog" width="460px"> 
          <el-form :model="passForm" label-width="90px" label-position="left">
            <el-form-item label="旧密码">
              <el-input v-model="passForm.oldPass"></el-input>
            </el-form-item>
            <el-form-item label="新密码">
              <el-input v-model="passForm.newPass"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="modifyPasswordDialog = false">取 消</el-button>
            <el-button type="primary" @click="confirmModifyPassword">确 定</el-button>
          </div>
      </el-dialog>
    </div>
</template>

<script>
import LayoutHeader from "./LayoutHeader.vue";
import LayoutAside from "./LayoutAside.vue";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      isIndex: true,
      modifyPasswordDialog: false,
      passForm: {
        oldPass: "",
        newPass: ""
      },
      merchantName: ""
    };
  },
  components: {
    LayoutHeader,
    LayoutAside
  },
  computed: {
    breadcrumbList() {
      return this.$route.meta;
    }
  },
  methods: {
    ...mapActions({
      _modifyPassword: "modifyPassword"
    }),
    async confirmModifyPassword() {
      if (!this.passForm.oldPass) {
        this.$message.error("旧的密码不能为空！");
        return;
      }
      if (!this.passForm.newPass) {
        this.$message.error("新的密码不能为空！");
        return;
      }
      const res = await this._modifyPassword({
        old_password: this.passForm.oldPass,
        new_password: this.passForm.newPass
      });
      if (res.code == 0) {
        this.$message.success("成功修改密码");
        this.modifyPasswordDialog = false;
        this.$router.push({ name: "Login" });
      } else {
        this.$message.error(res.msg);
      }
    },
    scroll() {
      // let headerScrollTop =
      //   document.querySelector(".header-turnover-wrapper").clientHeight +
      //   document.querySelector(".chart-turnover-wrapper").clientHeight +
      //   40;
      let scroll = document.querySelector(".view-wrapper");
      let currentScrollTop = scroll.scrollTop;
      let timer = setInterval(() => {
        currentScrollTop -= 50;
        scroll.scrollTop = currentScrollTop;
        if (currentScrollTop <= 0) {
          clearInterval(timer);
          scroll.scrollTop = 0;
        }
      }, 1);
    }
  },
  watch: {
    $route(to, from) {
      if (
        to.path == "/" ||
        to.path == "/super/index" ||
        to.path == "/merchant/company_index" ||
        to.path == "/merchant/shop_index" ||
        to.path == "/shop/index"
      ) {
        this.isIndex = true;
      } else {
        this.isIndex = false;
      }
    }
  },
  created() {
    if (
      this.$route.path == "/" ||
      this.$route.path == "/super/index" ||
      this.$route.path == "/merchant/company_index" ||
      this.$route.path == "/merchant/shop_index" ||
      this.$route.path == "/shop/index"
    ) {
      this.isIndex = true;
    } else {
      this.isIndex = false;
    }
    if (sessionStorage.getItem("accountInfo")) {
      if (JSON.parse(sessionStorage.getItem("accountInfo")).account_type == 2) {
        this.merchantName = JSON.parse(
          sessionStorage.getItem("accountInfo")
        ).company_name;
      } else if (
        JSON.parse(sessionStorage.getItem("accountInfo")).account_type == 1
      ) {
        this.merchantName = JSON.parse(
          sessionStorage.getItem("accountInfo")
        ).shop_name;
      }
    }
  },
  mounted() {
    this.$root.eventHub.$on("scroll", data => {
      // 处理数据
      this.scroll();
    });
    this.$root.eventHub.$on("passwordDialog", data => {
      // 处理数据
      this.modifyPasswordDialog = true;
    });
  }
};
</script>

<style lang='scss'>
.layout-root {
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  .el-header {
    padding: 0;
  }
  .el-container {
    height: 100%;
    .el-aside {
      min-height: 100%;
      overflow-x: hidden;
    }
    .el-main {
      padding: 0;
      overflow: hidden;
      .root-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        .crumbs-wrapper {
          height: 38px;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          border-top: 1px solid #ebebeb;
          border-bottom: 1px solid #ebebeb;
          user-select: none;
        }
        .view-wrapper {
          flex: 1;
          padding: 10px 20px;
          box-sizing: border-box;
          overflow-y: auto;
          overflow-x: hidden;
          background: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/LayoutRoot.vue